import { emit } from "./eventEmitter";

const original = global.fetch;

/**
 * 
 * @param  {...Parameters<fetch>} args 
 * @returns {ReturnType<fetch>}
 */
global.fetch = async (...args) => {
  try {
    const response = await original(...args);

    const clone = response.clone();

    const data = await clone.json().catch(() => {});

    if (data?.code?.toLowerCase?.() === 'blocked') {
      emit('blocked', data);
    }

    return response;
  } catch (error) {
    throw error;
  }
};
